module.exports = __webpack_public_path__ + "static/media/diamonds_J.e25dde16.png";